<template>
  <head>
    <title>{{ $t("OurPartneres.title") }}</title>
    <meta
      name="description"
      :content="
        $i18n.locale === 'ar' ? 'تصفح شركائنا' : 'Check out our partners'
      "
    />
  </head>
  <div class="our-partners">
    <NavbarComponent />
    <!-- ======= Breadcrumbs ======= -->
    <div
      class="breadcrumbs d-flex align-items-center"
      style="background-image: url('assets/img/ourservice.jpg')"
      id="our-partners"
    >
      <div
        class="container position-relative d-flex flex-column align-items-center"
      >
        <h2>{{ $t("OurPartneres.title") }}</h2>
        <ol>
          <li>
            <a href="/">{{ $t("home") }}</a>
          </li>
          <li>{{ $t("OurPartneres.title") }}</li>
        </ol>
      </div>
    </div>
    <!-- End Breadcrumbs -->
    <!-- ======= About Section ======= -->
    <section class="about">
      <div class="container" data-aos="fade-up">
        <div
          class="row gy-4 my-3"
          data-aos="fade-up"
          v-for="(item, index) in data"
          :key="index"
        >
          <div class="col-lg-3 d-flex align-items-center">
            <img
              :src="$store.state.server + item.img"
              class="img-fluid"
              alt=""
            />
          </div>
          <div class="col-lg-9 d-flex align-items-center">
            <div class="content ps-lg-5">
              <h3>{{ $i18n.locale == "ar" ? item.name_ar : item.name_en }}</h3>
              <p>
                {{
                  $i18n.locale === "ar"
                    ? item.description_ar
                    : item.description_en
                }}
              </p>
              <a :href="item.link" target="_blank" v-if="item.link">{{
                $i18n.locale == "ar"
                  ? "تصفح موقع شريكنا الاستراتيجي"
                  : "Check our Strategic Partner website"
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End About Section -->
  </div>
</template>

<script>
import NavbarComponent from "@/components/NavbarComponent.vue";
import store from "@/store";
import axios from "axios";
export default {
  name: "our-partners",
  components: {
    NavbarComponent,
  },
  data() {
    return {
      data: [],
    };
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_all_partners")
        .then((response) => {
          this.data = response.data;
          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.blog .posts-list .title-blog {
  font-size: 20px;
  font-weight: 600;
  padding: 0;
  margin: 20px 0 0 0;
}

a {
  color: var(--color-secondary);
  transition: 0.3s;
}

a:hover {
  color: var(--color-primary);
}
</style>
